export { default } from './offers.vue'
